import * as React from 'react';
import { InjectedRouter } from 'react-router';

interface IProps {
	router: InjectedRouter;
	route: { to: string };
}

class RedirectOnLoad extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public componentDidMount() {
		this.props.router.replace(this.props.route.to);
	}

	public render() {
		return '';
	}
}

export { RedirectOnLoad };
